
import {initWebComponent} from "@/helpers/web-component-helper";
import {getActiveFilterFormAttributeByKey, getActiveFilterUrl} from "@/helpers/filter/filter-helper";
import $ from "jquery";
import datepicker from 'bootstrap-datepicker'
import {updateFilterBadge} from "@/helpers/filter/filter-settings-helper";
import {initDatePickerSettings} from "@/helpers/date-picker-helper.js";

export class LayerInfoFilterSettingsDateComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const label = this.getAttribute('data-label')
        const formAttribute = getActiveFilterFormAttributeByKey(key)

        const template = document.createElement('template');

        if(label === 'Tussen') {
             template.innerHTML = `
            <div class="row">
                <div class="col-2"><div class="form-group mt-2">Vanaf</div></div>
                <div class="col-4" data-test="layer_info_filter_settings_data_from"><input type="text" class="form-control"></div>
                <div class="col-2"><div class="form-group mt-2">Tot</div></div>
                <div class="col-4" data-test="layer_info_filter_settings_data_til"><input type="text" class="form-control"></div>
            </div>`;
        } else {
             template.innerHTML = `
            <div class="row">
                <div class="col-2"><div class="form-group mt-2">` + label + `</div></div>
                <div class="col-10"><input type="text" class="form-control"></div>
            </div>`;
        }

        initWebComponent(this, template)

        initDatePickerSettings()

        let parent = this
        this.querySelectorAll('input').forEach(element => {
            $(element).datepicker({
                format: 'dd-mm-yyyy',
                weekStart: 1,
                language: 'nl',
                orientation: 'bottom',
                autoclose: true,
                clearBtn: true,
            }).on('changeDate', function(e) {
                $(this).datepicker('hide');

                let values = []
                parent.querySelectorAll('input').forEach( element => {
                    if(element.value !== "") {
                        values.push(element.value)
                    }
                })
                let value = values.join(' - ')
                if(value.length > 0) {
                    value = label + ': ' + value
                }
                updateFilterBadge(this, value)
            });
        })
    }
}
